import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { StatusToDoIcon20Artwork as n } from "../assets/artwork/StatusToDoIcon20Artwork.js";
import { StatusToDoIcon24Artwork as r } from "../assets/artwork/StatusToDoIcon24Artwork.js";
import { jsx as i } from "react/jsx-runtime";
var a = {
	12: {
		Artwork: (e) => /* @__PURE__ */ i(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: /* @__PURE__ */ i("circle", {
				cx: 5.99999,
				cy: 5.99999,
				r: 4.25625,
				stroke: "#8F8B85",
				strokeWidth: .9375
			})
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ i(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ i("circle", {
				cx: 8.00001,
				cy: 8.00001,
				r: 5.675,
				stroke: "#8F8B85",
				strokeWidth: 1.25
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: n,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, o = ({ size: t = 16, ...n }) => /* @__PURE__ */ i(e, {
	source: a[t],
	...n
});
//#endregion
export { o as StatusScheduledIcon };
